import React from 'react';
import { Box, makeStyles, Typography, CardMedia } from '@material-ui/core';
import { ReactComponent as PlayIcon } from '../../img/play.svg';
import imgParams from '../../utils/imageUtil';
import { useDimensions } from '../../hooks/utilHooks';

const VideoContent = ({ post, isPostDetail }) => {
  const classes = useStyles();
  const { width, ref } = useDimensions();

  return (
    <React.Fragment>
      <Box
        className="cursorPointer videoContent"
        whiteSpace="pre-line"
        pb={2}
        px={4}
      >
        <Typography variant="body1" color="textPrimary" component="span">
          {post.description !== 'null' && (
            <div
              dangerouslySetInnerHTML={{
                __html: post.description,
              }}
            ></div>
          )}
        </Typography>
      </Box>

      {!isPostDetail && (
        <Box className="positionRelative cursorPointer" pb={1} px={4}>
          <CardMedia
            ref={ref}
            className={classes.media}
            image={imgParams(post.videoThumbnailUrl, width * 2, 340 * 2)}
            title="Thumbnail Video"
          />
          <PlayIcon className={classes.playIcon} />
        </Box>
      )}

      <Box>
        {isPostDetail && (
          <div className={classes.videoContainer}>
            <video
              width="100%"
              autoPlay={true}
              controls="controls"
              loop
              className={classes.videoInner}
            >
              <source
                src={
                  post.isVideoStreamingEnabled
                    ? post.videoUrl
                    : post.sourceVideoUrl
                }
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>
        )}
      </Box>
    </React.Fragment>
  );
};

const useStyles = makeStyles((theme) => ({
  media: {
    height: 0,
    paddingTop: '66.67%',
    borderRadius: theme.spacing(3),
  },
  playIcon: {
    height: '100%',
    position: 'absolute',
    left: 0,
    right: 0,
    display: 'flex',
    top: 0,
    margin: '0px auto',
  },
  videoContainer: {
    position: 'relative',
    overflow: 'hidden',
    paddingTop: '66.67%',
  },
  videoInner: {
    backgroundColor: '#000',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
}));

export default VideoContent;
